import { render, staticRenderFns } from "./NavbarLanguageSwitch.vue?vue&type=template&id=8d200484&"
import script from "./NavbarLanguageSwitch.vue?vue&type=script&lang=js&"
export * from "./NavbarLanguageSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports